import React from 'react';

const PillGroup = ({ options = [], value, onChange, name }: any) => (
    <div className="cs-pill-group" role="radiogroup" aria-label={name}>
        {options.map((opt: any) => (
            <button
                type="button"
                key={String(opt.value)}
                className={`cs-pill${value === opt.value ? ' cs-pill--active' : ''}`}
                onClick={() => onChange(opt.value)}
                role="radio"
                aria-checked={value === opt.value}
            >
                {opt.label}
            </button>
        ))}
    </div>
);

export default PillGroup;